<template>
	<div id="you-can-do-it" class="wrap py-sm-16 pt-14 pb-12 px-4">
		<h1
			class="mt-sm-4 mb-6 main--title text-left text-sm-center"
			v-html="$t('you-can-do-it.title')"
		></h1>
		<h2
			class="sub--title d-flex align-center justify-left justify-sm-center mb-sm-10"
		>
			<img
				src="@/assets/images/check-box.png"
				alt=""
				class="mr-1"
				:width="userDevice === 'desktop' ? 30 : 25"
			/>
			{{ $t('you-can-do-it.sub-title') }}
		</h2>

		<v-img
			width="430"
			:src="require(`@/assets/images/graph-${language}.png`)"
			alt=""
			class="mx-auto"
		/>
		<p
			class="mb-0 text-center text mt-5 mt-sm-11 pb-sm-4"
			v-html="$t('you-can-do-it.text')"
		></p>
	</div>
</template>

<script>
export default {
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-color: #f1f5ff;
}
.main--title {
	font-size: 30px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -1.5px;
	color: #1a1a1a;
}

.sub--title {
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.9px;
	color: #000;
}
@media screen and (max-width: 600px) {
	.sub--title {
		font-size: 16px;
		letter-spacing: -0.8px;
		color: #1a1a1a;
	}
}
.text {
	font-size: 20px;
	letter-spacing: -1px;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	color: #1a1a1a;
}
@media screen and (max-width: 600px) {
	.text {
		font-size: 16px;
		letter-spacing: -0.8px;
	}
}
</style>
